// src/shared/components/Header/Header.tsx

import React from 'react';
import { NavLink } from 'react-router-dom';
import BurgerMenu from '../BurgerMenu/BurgerMenu';
import ThemeToggle from './ThemeToggle';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import styles from './Header.module.scss';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';

const Header: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const { t } = useTranslation();

  return (
    <AnimatePresence>
        <motion.header
          className={styles.header}
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          exit={{ y: -100 }}
          transition={{ duration: 0.69, ease: 'easeInOut' }}
        >
          {/* Left Side */}
          {isMobile ? (
            <div className={styles.leftControls}>
              <BurgerMenu />
            </div>
          ) : (
            <nav className={styles.navMenu}>
              <NavLink to="/" end>
                01. {t('navigation.home')}
              </NavLink>
              <NavLink to="/projects">
                02. {t('navigation.projects')}
              </NavLink>
              <NavLink to="/contact">
                03. {t('navigation.contact')}
              </NavLink>
            </nav>
          )}

          {/* Right Side */}
          <div className={styles.rightControls}>
            <LanguageSwitcher />
            <ThemeToggle />
          </div>
        </motion.header>
    </AnimatePresence>
  );
};

export default Header;